<template>
  <header id="header" class="pc">
    <div class="title-wrapper">
      <div style="display: flex; gap:50px;">
        <div class="logo-area">
          <img src="../../../assets/web/images/logo.png" alt="문화셈터" style="width: 70px; height: 36px; display: inline-block; ">
        </div>
        <div class="header-title">
          <h2>지역별 관광통계 현황</h2>
          <select v-model="year" id="year" @change="onChangeYear">
            <option :value="data" v-for="(data, idx) in yearList" v-bind:key="idx">{{ data }}</option>
          </select>
        </div>
      </div>
<!--      <div class="header-btn">-->
<!--        <button class="menu">통계메뉴</button>-->
<!--        <button class="main-page">메인페이지</button>-->
<!--      </div>-->
    </div>
  </header>
</template>

<script>
import { eventBus } from '@/event-bus'

export default {
  name: 'BoardHeader',
  mounted () {

  },
  data () {
    return {
      year: '2022',
      yearList: ['2022', '2021', '2020', '2019']
    }
  },
  methods: {
    onChangeYear() {
      eventBus.$emit('sendBoardYear', this.year)
    }
  }
}
</script>

<style scoped>
#header.pc {
  width: 100%;
}

.title-wrapper {
  height: 35px;
  padding: 0 40px 0 20px;
  display: flex;
  justify-content: space-between;
  margin: 21px 0;
  background-color: #ffffff;
}
.header-title {
  display: flex;
  gap: 12px;
}
.header-title > h2 {
  font-size: 25px;
  font-weight: bold;
  padding-left: 7px;
}

select {
  border: 1px solid #cccccc;
  border-radius: 20px;
  height: 35px;
  background-repeat: no-repeat;
  padding-left: 37px !important;
  background-color: #ffffff;
}

.header-title > select {
  width: 188px;
  background-image: url(~@/assets/web/images/calendar.png), url(~@/assets/web/images/down-arrow.png);
  background-position: calc(100% - 160px), calc(100% - 11px);
  background-size: 14px 16px, 16px 8px;
}
.header-title > select > option {
  font-size: 16px;
}
.header-btn {
  width: 290px;
  display: flex;
  gap: 6px;
}
.menu {
  height: 100%;
  border: 2px solid #44537a;
  border-radius: 25px;
  color: #44537a;
  font-size: 16px;
  padding: 0 30px;
}
.main-page {
  height: 100%;
  border: 2px solid #44537a;
  background-color: #44537a;
  border-radius: 25px;
  color: #fff;
  font-size: 16px;
  padding: 0 33px;
}
</style>
